import React, { useState, useEffect } from 'react';
import Layout from '../layout/Layout'
import { Grid, Typography } from '@mui/material'
import { GrHomeRounded } from 'react-icons/gr'
import { FaRankingStar } from 'react-icons/fa6'
// import { Pie } from 'react-chartjs-2';

import './informacion.css'

function Informacion(props) {
    const [selectedCategory, setSelectedCategory] = useState('General');
    const [generalData, setGeneralData] = useState(null);

    useEffect(() => {
        // Aquí haces la llamada al servicio y actualizas el estado con los datos devueltos
        const fetchData = async () => {
            try {
                const response = await fetch('/gate/info');
                const data = await response.json();
                setGeneralData(data);
            } catch (error) {
                console.error('Error fetching data:', error);
                // En caso de error, establece los datos generales como nulos
                setGeneralData(null);
            }
        };

        fetchData();
    }, []);

    const handleCategoryClick = (category) => {
        setSelectedCategory(category);
    };

    // const data = {
    //     labels: ['Guerreros', 'Magos', 'Elfas', 'Gladiadores', 'Dark Lords'],
    //     datasets: [
    //         {
    //             label: 'My First Dataset',
    //             data: [
    //                 generalData ? generalData.personajesGuerreros : 1,
    //                 generalData ? generalData.personajesMagos : 1,
    //                 generalData ? generalData.personajesElfas : 1,
    //                 generalData ? generalData.personajesGladiadores : 1,
    //                 generalData ? generalData.personajesDarkLords : 1
    //             ],
    //             backgroundColor: [
    //                 'rgba(255, 99, 132 )',
    //                 'rgba(54, 162, 235 )',
    //                 'rgba(255, 206, 86 )',
    //                 'rgba(75, 192, 192 )',
    //                 'rgba(153, 102, 255 )',
    //                 'rgba(255, 159, 64 )',
    //             ],
    //             borderColor: [
    //                 'rgba(255, 99, 132 )',
    //                 'rgba(54, 162, 235 )',
    //                 'rgba(255, 206, 86 )',
    //                 'rgba(75, 192, 192 )',
    //                 'rgba(153, 102, 255 )',
    //                 'rgba(255, 159, 64)',
    //             ],
    //             borderWidth: 1,
    //         },
    //     ],
    // };

    // const PieChart = () => (
    //     <>
    //         <Pie data={data} />
    //     </>
    // );

    return (
        <Layout tyExpanded={props.tyExpanded} setExpanded={props.setExpanded}>
            <Grid style={{ display: 'flex', flexDirection: 'column', gap: '35px', padding: '2rem 5.8rem' }}>
                <Typography style={{ color: 'white', fontSize: '20px', display: 'flex', gap: '5px', alignItems: 'center' }}> <FaRankingStar style={{ color: '#856ffc' }} />
                    Información</Typography>

                <div className="usersettings-navbar">
                    <Grid>
                        <Grid style={{ display: 'flex', padding: '5px 5px', backgroundColor: '#2a2e38', borderRadius: '5px', gap: '15px', width: '60%' }}>
                            {['General', 'Resets', 'Stats', 'Mapas', 'Eventos', 'Silver Coins', 'Atajos y Comandos'].map((category) => (
                                <Grid
                                    key={category}
                                    onClick={() => handleCategoryClick(category)}
                                    className={selectedCategory === category ? 'item-config-active' : 'item-config'}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                        padding: '10px',
                                        backgroundColor: selectedCategory === category ? '#343843' : '#2a2e38',
                                        borderRadius: '5px',
                                    }}
                                >
                                    <GrHomeRounded style={{ color: 'white' }} />
                                    <Typography style={{ color: 'white' }}>{category}</Typography>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </div>

                {selectedCategory === 'General' && (
                    <div className="usersettings-settings">
                        <div className="usersettings-change-avatar">
                            <h3>Datos generales</h3>
                            <div className="usersettings-card">
                                <div style={{ textAlign: "center", display: 'flex', alignItems: 'center', gap: '10px', width: '80%', justifyContent: 'space-between', padding: '15px 15px', backgroundColor: '#343843', borderRadius: '5px' }}>
                                    <Grid style={{ display: 'flex', gap: '10px', alignItems: 'center', padding: '0px 15px', borderRight: '1px solid #080808', width: '30%' }}>
                                        <Grid style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                            <Typography>Cuentas</Typography>
                                            <Typography style={{ fontWeight: 600 }}>{generalData ? generalData.cuentasCreadas : '--'}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid style={{ display: 'flex', gap: '10px', alignItems: 'center', padding: '0px 15px', borderRight: '1px solid #080808', width: '30%' }}>
                                        <Grid style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                            <Typography>Personajes</Typography>
                                            <Typography style={{ fontWeight: 600 }}>{generalData ? generalData.personajesCreados : '--'}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid style={{ display: 'flex', gap: '10px', alignItems: 'center', padding: '0px 15px', width: '30%' }}>
                                        <Grid style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                            <Typography>Usuarios Online</Typography>
                                            <Typography style={{ fontWeight: 600 }}>{generalData ? generalData.jugadoresOnline : '--'}</Typography>
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        </div>
                        <div className="usersettings-change-avatar">
                            <h3>Configuración del Servidor</h3>
                            <div className="usersettings-card">
                                <div style={{ textAlign: "left", padding: '10px' }}>
                                    <Typography>Versión: Legendaria (versión propia)</Typography>
                                    <Typography>Experiencia: 500x</Typography>
                                    <Typography>Drop: 40%</Typography>
                                    <Typography>Party Bonus: 1% de experiencia adicional por cada jugador del party sin distinguir razas.</Typography>
                                    <Typography>Límite de Zen: Infinito. Puedes obtener, intercambiar y almacenar tanto zen como desees.</Typography>
                                    <Typography>Creación de personajes: no hay restricciones de nivel, puedes elegir cualquiera de nuestras 5 razas al momento de crear tu cuenta.</Typography>
                                </div>
                            </div>
                        </div>
                        {/* <div className="usersettings-change-avatar">
                            <h3>Distribución de personajes por raza</h3>
                            <div className="usersettings-card">
                                <div style={{ textAlign: "center", display: 'flex', alignItems: 'center', gap: '10px', width: '100%', justifyContent: 'space-between', padding: '15px 15px' }}>
                                    <Grid style={{ display: 'flex', gap: '10px', alignItems: 'center', padding: '0px 15px' }}>
                                        <Grid style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                            <PieChart />
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        </div> */}
                    </div>
                )}
                {selectedCategory === 'Resets' && (
                    <div className="usersettings-settings">
                        <div className="usersettings-change-avatar">
                            <h3>Resets</h3>
                            <div className="usersettings-card">
                                <div style={{ textAlign: "left", padding: '10px' }}>
                                    <Typography>Para realizar un reset, es necesario alcanzar el nivel 400.</Typography>
                                    <Typography>La cantidad máxima de resets permitidos es 400 ("maxear").</Typography>
                                    <Typography>Cada reset tiene un coste de zen asociado.</Typography>
                                    <Typography>El reset borra stats y otorga 655 puntos (818 para Dark Lords).</Typography>
                                    <Typography>Puedes ver los requisitos para tu próximo reset y realizarlo en "Reset NPC", ubicado en la entrada del bar Lorencia.</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {selectedCategory === 'Stats' && (
                    <div className="usersettings-settings">
                        <div className="usersettings-change-avatar">
                            <h3>Stats</h3>
                            <div className="usersettings-card">
                                <div style={{ textAlign: "left", padding: '10px' }}>
                                    <Typography>Todas las razas reciben 5 puntos para repartir por cada nivel obtenido.</Typography>
                                    <Typography>El máximo para cada stat es 65.500 puntos.</Typography>
                                    <Typography>Puedes repartir puntos de forma masiva y sin costo utilizando la tecla 'S' en el juego.</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {selectedCategory === 'Mapas' && (
                    <div className="usersettings-settings">
                        <div className="usersettings-change-avatar">
                            <h3>Mapas</h3>
                            <div className="usersettings-card">
                                <div style={{ textAlign: "left", padding: '10px' }}>
                                    <Typography>Actualmente disponemos de los siguientes mapas:</Typography>
                                    <Typography>Stadium, Lorencia, Noria, Davias, Dungeon, Atlans, LostTower, Tarkan, Icarus, Aida, Land of Trials, Kanturu, Relic, Raklion</Typography>
                                    <Typography>Puedes acceder a ellos usando portales o utilizando la tecla 'M' en el juego.</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {selectedCategory === 'Eventos' && (
                    <div className="usersettings-settings">
                        <div className="usersettings-change-avatar">
                            <h3>Eventos</h3>
                            <div className="usersettings-card">
                                <div style={{ textAlign: "left", padding: '10px' }}>
                                    <Typography>Blood Castle</Typography>
                                    <Typography>Devil Square</Typography>
                                    <Typography>Invasión de Dragones Dorados</Typography>
                                    <Typography>Invasión de White Wizard</Typography>
                                    <Typography>Invasión de Gran Dragón Rojo</Typography>
                                    <Typography>Invasión de Lord of Kundun</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {selectedCategory === 'Silver Coins' && (
                    <div className="usersettings-settings">
                        <div className="usersettings-change-avatar">
                            <h3>Silver Coins</h3>
                            <div className="usersettings-card">
                                <div style={{ textAlign: "left", padding: '10px' }}>
                                    <Typography>Puedes conseguir monedas haciendo diferentes tareas como resetear, hacer pk puntos y participar en eventos.</Typography>
                                    <Typography>Úsalas para adquirir interesantes items en la tienda del juego (ingresa utilizando la tecla 'X').</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {selectedCategory === 'Atajos y Comandos' && (
                    <div className="usersettings-settings">
                        <div className="usersettings-change-avatar">
                            <h3>Atajos y Comandos</h3>
                            <div className="usersettings-card">
                                <div style={{ textAlign: "left", padding: '10px' }}>
                                    <Typography>Control de sonido: Utiliza las teclas F1 (Activar), F2 (Bajar Volumen), F3 (Subir Volumen) y F4 (Silencio) para ajustar el sonido.</Typography>
                                    <Typography>Autoataque: Presiona la tecla F9 para activar o desactivar la función de autoataque.</Typography>
                                    <Typography>Minimizer: Presione la tecla F10 para minimizar el juego a la bandeja del sistema.</Typography>
                                    <Typography>Comando /post: Envía un mensaje a todos los jugadores en el servidor. Costo: 10.000.000 zen.</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Grid>
        </Layout>
    )
}

export default Informacion